// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

var customer_check_exists = Config$PorterinUtils.wag_url + "/customer/onboarding/exist_otp";

var customer_signup = Config$PorterinUtils.wag_url + "/customer/onboarding/signup";

var customer_validate_otp = Config$PorterinUtils.wag_url + "/customer/onboarding/validation";

var customer_resend_sms_otp = Config$PorterinUtils.wag_url + "/customer/onboarding/resend_otp";

var customer_resend_whatsapp_otp = Config$PorterinUtils.wag_url + "/customer/onboarding/resend_otp/whatsapp";

var customer_logout = Config$PorterinUtils.wag_url + "/customer/onboarding/logout";

var customer_profile = Config$PorterinUtils.wag_url + "/customer/profile";

var header_brand = "smartshift";

var header_source = "website";

var header_app_language = "en";

var min_otp_char_length = 0;

var max_otp_char_length = 6;

var min_name_char_length = 3;

var max_name_char_length = 50;

var resend_otp_timer = 10;

var max_resend_attempts = 3;

var cookie_expiration_days = 7;

var modal_close_timeout = 500;

export {
  customer_check_exists ,
  customer_signup ,
  customer_validate_otp ,
  customer_resend_sms_otp ,
  customer_resend_whatsapp_otp ,
  customer_logout ,
  customer_profile ,
  header_brand ,
  header_source ,
  header_app_language ,
  min_otp_char_length ,
  max_otp_char_length ,
  min_name_char_length ,
  max_name_char_length ,
  resend_otp_timer ,
  max_resend_attempts ,
  cookie_expiration_days ,
  modal_close_timeout ,
}
/* Config-PorterinUtils Not a pure module */
